import { ref, onMounted, onUnmounted } from 'vue';

export function useNetworkStatus() {
  const isOnline = ref(navigator.onLine);
  const connectionQuality = ref('good'); // 'good', 'slow', or 'offline'
  
  const updateOnlineStatus = () => {
    isOnline.value = navigator.onLine;
    if (!navigator.onLine) {
      connectionQuality.value = 'offline';
    }
  };
  
  const checkConnectionSpeed = async () => {
    if (!navigator.onLine) {
      connectionQuality.value = 'offline';
      return;
    }
    
    try {
      const startTime = Date.now();
      await fetch('https://www.cloudflare.com/cdn-cgi/trace', {
        cache: 'no-store',
        mode: 'no-cors'
      });
      const endTime = Date.now();
      
      const duration = endTime - startTime;
      
      // Consider connection slow if ping takes more than 1.5 seconds
      connectionQuality.value = duration > 1500 ? 'slow' : 'good';
    } catch (error) {
      // If we can't fetch, connection might be very slow or restricted
      connectionQuality.value = 'slow';
    }
  };
  
  const periodicCheck = () => {
    checkConnectionSpeed();
  };
  
  let intervalId = null;
  
  onMounted(() => {
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
    
    // Initial check
    checkConnectionSpeed();
    
    // Set up periodic checking every 30 seconds
    intervalId = setInterval(periodicCheck, 30000);
  });

  onUnmounted(() => {
    window.removeEventListener('online', updateOnlineStatus);
    window.removeEventListener('offline', updateOnlineStatus);
    
    if (intervalId) {
      clearInterval(intervalId);
    }
  });

  return { isOnline, connectionQuality };
}
